/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
/**
 * 
 * @export
 * @interface DeviceInfo
 */
export interface DeviceInfo {
    /**
     * 
     * @type {number}
     * @memberof DeviceInfo
     */
    no?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    area?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfo
     */
    stationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    stationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    stationName?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfo
     */
    channel?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfo
     */
    manageSerial?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    trigger?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    commercialPower?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    upsError?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    batteryStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof DeviceInfo
     */
    lastReceived?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    upsVendor?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceInfo
     */
    lqi?: string;
}

export function DeviceInfoFromJSON(json: any): DeviceInfo {
    return DeviceInfoFromJSONTyped(json, false);
}

export function DeviceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'no': !exists(json, 'no') ? undefined : json['no'],
        'area': !exists(json, 'area') ? undefined : json['area'],
        'stationId': !exists(json, 'stationId') ? undefined : json['stationId'],
        'stationNumber': !exists(json, 'stationNumber') ? undefined : json['stationNumber'],
        'stationName': !exists(json, 'stationName') ? undefined : json['stationName'],
        'channel': !exists(json, 'channel') ? undefined : json['channel'],
        'manageSerial': !exists(json, 'manageSerial') ? undefined : json['manageSerial'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'trigger': !exists(json, 'trigger') ? undefined : json['trigger'],
        'commercialPower': !exists(json, 'commercialPower') ? undefined : json['commercialPower'],
        'upsError': !exists(json, 'upsError') ? undefined : json['upsError'],
        'batteryStatus': !exists(json, 'batteryStatus') ? undefined : json['batteryStatus'],
        'lastReceived': !exists(json, 'lastReceived') ? undefined : (json['lastReceived'] === null ? null : new Date(json['lastReceived'])),
        'upsVendor': !exists(json, 'upsVendor') ? undefined : json['upsVendor'],
        'lqi': !exists(json, 'lqi') ? undefined : json['lqi'],
    };
}

export function DeviceInfoToJSON(value?: DeviceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'no': value.no,
        'area': value.area,
        'stationId': value.stationId,
        'stationNumber': value.stationNumber,
        'stationName': value.stationName,
        'channel': value.channel,
        'manageSerial': value.manageSerial,
        'deviceId': value.deviceId,
        'trigger': value.trigger,
        'commercialPower': value.commercialPower,
        'upsError': value.upsError,
        'batteryStatus': value.batteryStatus,
        'lastReceived': value.lastReceived === undefined ? undefined : (value.lastReceived === null ? null : value.lastReceived.toISOString()),
        'upsVendor': value.upsVendor,
        'lqi': value.lqi,
    };
}


